import { render, staticRenderFns } from "./ServiceIconCreate.vue?vue&type=template&id=c1538138&"
import script from "./ServiceIconCreate.vue?vue&type=script&lang=js&"
export * from "./ServiceIconCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports